import { type numeric } from '@core/type/numeric'
import { TO_NUMBER } from '@core/util/convert.util'
import { environment } from '@env/environment'
import { DateTime, Settings } from 'luxon'

export const INITIAL_TZ: string = environment.timezone
export const SET_TZ = (tz: string): void => { Settings.defaultZone = tz }
export const GET_TZ = (): string => Settings.defaultZone.name

export const FORMAT = {
  ymd: 'y-MM-dd',
  hm: 'HH:mm',
  hms: 'HH:mm:ss',
  ymdHms: 'y-MM-dd HH:mm:ss',
  localYmd: 'D',
  localHm: 'T',
  localHms: 'TT',
  localYmdHm: 'D T',
  localYmdHms: 'D TT',
  localYmdHmsZ: 'D TT (z)'
}

export const NOW_UTC = (): DateTime => DateTime.utc()
export const NOW = (): DateTime => DateTime.local()
export const NOW_APP = (): DateTime => NOW().setZone(GET_TZ() ?? 'UTC')
export const NOW_MS = (): number => NOW().toMillis()
export const NOW_UNIX = (): number => Math.trunc(NOW().toSeconds())

export const MYSQL_DATETIME_NOW_UTC = (): string => NOW_UTC().toFormat(FORMAT.ymdHms)

export const waitMs = async (ms: numeric): Promise<void> => { await new Promise(resolve => setTimeout(resolve, TO_NUMBER(ms))) }

export const GET_TIMEZONE_OFFSET = (timestampMs: number): number => -DateTime.fromMillis(timestampMs).setZone(GET_TZ()).offset
